export default __webpack_public_path__ + "static/media/discover.94e8c6c4.png";